interface UpdateItem {
  date: string;
  title: string;
  tag: string;
  desc: string;
}

const updateItems: UpdateItem[] = [
  {
    date: '2025.07.31',
    title: '《流浪地球3》导演剪辑版独家上线',
    tag: '新片上线',
    desc: '比院线版多出 28 分钟独家内容，包含未曝光的支线剧情与幕后花絮，4K HDR 高码率版本同步推出。',
  },
  {
    date: '2025.07.30',
    title: '暑期档专题「清凉一夏」正式上线',
    tag: '专题策划',
    desc: '精选 50 部适合夏天观看的电影，从清新治愈到爆笑喜剧，搭配独家影评和观影指南。',
  },
  {
    date: '2025.07.29',
    title: '播放器升级至 V3.2 版本',
    tag: '功能更新',
    desc: '新增智能画质调节、AI 字幕翻译和记忆播放进度功能，观影体验全面优化。',
  },
  {
    date: '2025.07.28',
    title: '港片经典修复计划首批片单公布',
    tag: '片库更新',
    desc: '《东邪西毒》《重庆森林》《英雄本色》等 12 部经典港片已完成 4K 修复，即日上线。',
  },
  {
    date: '2025.07.27',
    title: '《封神第二部》票房突破 50 亿',
    tag: '行业快讯',
    desc: '成为中国影史第四部破 50 亿的国产电影，海外上映计划已覆盖 40 余个国家和地区。',
  },
  {
    date: '2025.07.26',
    title: '纪录片频道「真实视界」上线',
    tag: '频道上新',
    desc: '全新纪录片频道涵盖自然、历史、科技、人文四大板块，首批上线 200+ 部高分纪录片。',
  },
  {
    date: '2025.07.25',
    title: '午马影院移动端下载量突破 500 万',
    tag: '平台动态',
    desc: '移动端 App 上架半年下载量突破 500 万，新增投屏功能和离线缓存模式。',
  },
  {
    date: '2025.07.24',
    title: '《奥本海默》深度影评专题发布',
    tag: '深度策划',
    desc: '从诺兰的非线性叙事到基里安·墨菲的演技巅峰，万字长文解读年度现象级电影。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新更新
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              午马影院每日动态一览，不错过每一个精彩瞬间
            </p>
          </div>
          <div className="max-w-3xl mx-auto">
            <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
              {updateItems.map((item, idx) => (
                <div
                  key={idx}
                  className={`relative pb-8 ${idx === updateItems.length - 1 ? 'pb-0' : ''}`}
                >
                  <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                  <div className="text-xs text-foreground-500 mb-1.5">{item.date}</div>
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}